import { render, staticRenderFns } from "./BookOptional.vue?vue&type=template&id=33e6efb8&scoped=true&"
import script from "./BookOptional.vue?vue&type=script&lang=js&"
export * from "./BookOptional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6efb8",
  null
  
)

export default component.exports